<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-select [(value)]="season">
          <mat-option *ngFor="let season of seasons | async" [value]="season"
            >{{ season - 1 }}/{{ season }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col">
      <mat-form-field>
        <mat-select [(value)]="league">
          <mat-option *ngFor="let l of leagues" [value]="l.sihfId">{{
            l.shortName
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col" *ngIf="showSeasonType">
      <mat-form-field>
        <mat-select [(value)]="seasonType" placeholder="Season Type">
          <mat-option *ngIf="!requireSeasonType">Any</mat-option>
          <mat-option *ngFor="let type of seasonTypes" [value]="type">{{
            type
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-checkbox
    *ngIf="showUndeliveredOnly"
    [checked]="undeliveredOnly"
    (change)="undeliveredOnly = $event.checked"
    >Only games not delivered yet</mat-checkbox
  >
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="[null, null]" class="close-button"
    >Cancel</button
  >
  <button
    mat-raised-button
    color="warn"
    class="sync-button"
    (click)="syncToCockpit()"
    >{{ confirmLabel }}</button
  >
</mat-dialog-actions>
